import type {KilnPlugin} from '../utils.js';
import {directionProvider} from './direction-provider.js';

export const defaultKilnPlugins: KilnPlugin[] = [directionProvider];
